export default {
  GNB_PRODUCT: "Product",
  GNB_PRICING: "Pricing",
  GNB_DEVELOPERS: "Developers",
  GNB_COMPANY: "Company",
  GNB_BLOG: "Blog",
  BTN_APPLY_PROGRAM: "Apply Now",
  BTN_START_ABTEST: "Start a free trial",
  BTN_CTA_A: "무료체험 시작하기",
  BTN_CTA_B: "둘러보기",
  BTN_CTA_C: "Create an A/B Test ",
  BTN_REQUEST_DEMO: "Request a Demo",
  BTN_REQUEST_DEMO_FOR_FREE: "Request Demo for free",
  BTN_REQUEST: "Submit",
  BTN_READ_MORE: "Read more",
  HACK_THE_PRODUCT_TITLE: "Hack the Product",
  HACK_THE_PRODUCT_DESC1:
    "Join the accelerating program for tech startups to enable a/b testing for building better software",
  HACK_THE_PRODUCT_DESC2: " ",
  TITLE_PROVE_DATA: "Prove all product changes with data",
  PRODUCT_DECISION_TITLE: "Right product decisions",
  PRODUCT_DECISION_DESC1: "Measure impact from ",
  PRODUCT_DECISION_DESC2: "statistically rigorous A/B testing",
  EASY_INTEGRATION_TITLE: "Developers come first",
  EASY_INTEGRATION_DESC: "Integration with server and client-side SDKs",
  EASY_INTEGRATION_BTN: "Learn how to use Hackle",
  REDUCE_RISK_TITLE: "Reduce risk on releases",
  REDUCE_RISK_DESC1: "Deploy code continuously ",
  REDUCE_RISK_DESC2: "and manage them separately",
  DATA_ANALYTICS_TITLE: "Data Analytics",
  DATA_ANALYTICS_DESC1: "Pay as you go - ",
  DATA_ANALYTICS_DESC2: "Affordable A/B Testing Platform",
  ABOUT_TITLE1: "Ready for building ",
  ABOUT_TITLE2: "better software?",
  ABOUT_BTN_SLACK: "Slack Community",
  COMPARISON_A_COMPANY: "A**",
  COMPARISON_A_PRICE: "$36,000/yr ~",
  COMPARISON_B_COMPANY: "B**",
  COMPARISON_B_PRICE: "$22,800/yr ~",
  COMPARISON_HACKLE_PRICE: "Free Trial",
  FOOTER_PRODUCT: "Product",
  FOOTER_AB_TESTING: "A/B Test",
  FOOTER_FUNNEL: "Funnel Analysis",
  FOOTER_PRICING: "Pricing",
  SERVICE_GUIDE: "Service Guide",
  FOOTER_SDK: "SDK",
  FOOTER_USER_MANUAL: "User Manual",
  FOOTER_FAQ: "FAQ",
  FOOTER_COMPANY: "Company",
  FOOTER_ABOUT: "About",
  FOOTER_CAREERS: "Careers",
  FOOTER_BLOG: "Blog",
  FOOTER_EMAIL: "E-mail",
  POLICY_TERMS_OF_SERVICE: "Terms of Service",
  POLICY_PRIVACY: "Privacy Policy",
  POLICY_COOKIE: "Cookie Policy",
  REQUIRED_EMAIL: "E-mail (required)",
  EMAIL: "E-mail",
  NAME: "Name",
  PHONE_NUMBER: "Contact Number",
  REQUEST_DEMO_COMMENT:
    "Please feel free to ask anything you'd like. \n" +
    "For example, tell us what you would like to achieve through the A/B test and the different types of A/B tests you would like to try out.",
  REQUEST_DEMO_TITLE: "Request a Demo",
  REQUEST_DEMO_DESC: "Learn how to make better product with data and a/b testing.",
  REQUESTED_DEMO_TITLE: "Thanks for booking a demo",
  REQUESTED_DEMO_DESC1: "Our expert will reach out to you shortly.",
  REQUESTED_DEMO_DESC2: " ",
  REQUESTED_DEMO_READ_MORE1: "Read more a/b testing insights on our blog:",
  REQUESTED_DEMO_READ_MORE2: " ",
  REQUESTED_DEMO_READ_MORE3: " ",
  BLOG_HACKLE_DESC: "Hackle co-founder explained about importance of a/b testing to startup.",
  BLOG_NETFLIX_DESC: "Learn about how Netflix selected the best artwork for videos through A/B testing.",
  BLOG_GRAB_DESC: "How can grab better engage with drivers and make cost efficient growth with a/b testing?",
  SUBMIT_AGREE_POLICY: "By submitting the form you agree to the {service}, {private} and {cookie}",
  ab_test: "A/B Test",
  feature_flag: "Feature Management",
  funnel: "Funnel Analysis",
  funnel_start_btn: "Create a Funnel Analysis",
  btn_ab_test_hero_section: "Create your A/B Test",
  btn_funnel_hero_section: "Create your Funnel Analysis",
  btn_feature_flag_hero_section: "Create your Feature Management",
  btn_feature_flag_start: "Create a Feature Management",
  service_description_feature_flag1: "장애 리스크를 줄이고 원하는 시점에",
  service_description_feature_flag2: "안전하게 기능을 출시하세요",
  search_more_btn: "Find out more",
  AB_TEST_SEARCH_MORE: "Find out more",
  COMPARE_PRICE: "Compare prices and services",
  FOOTER_SUPPORT: "Support",
  BTN_START_FUNNEL: "Create a Funnel Analysis",
  plan_name_1: "Free Startup Plan",
  plan_name_2: "Pro Plan",
  plan_name_3: "Enterprise Plan",
  btn_start_free: "Try For Free",
  inquire: "Request",
  free_plan: "Free Startup Plan",
  free_plan_desc: "Up to 100,000 events/month",
  btn_start_free_plan: "Get Started for free",
  basic_rate: `Base Fee \${amount}`,
  per_event: `Per 1000 Events \${amount}`,
  pro_plan: "Pro Plan",
  enterprise_plan: "Enterprise Plan",
  contact_us_separately: "Contact us",
  btn_inquire: "Contact us",
  plan_benefit_many_kinds_of_sdk: "SDKs in 10 languages",
  plan_benefit_test_platform_line1: "Web, mobile app, server-side",
  plan_benefit_test_platform_line2: "based A/B Tests and Feature Managements.",
  plan_benefit_change_real_time_line1: "A/B test, Feature Management",
  plan_benefit_change_real_time_line2: "modifications applied in real time",
  pro_plan_benefit_contain_free_plan: "무료 플랜 기능 모두 제공",
  pro_plan_benefit_free_trial_period: "14-day free-trial period",
  pro_plan_benefit_segment: "Detailed data analysis available",
  pro_plan_benefit_segment_sample: "(OS, language, region, etc.)",
  pro_plan_benefit_webinar: "웨비나, 오프라인 교육 우선권 제공",
  pro_plan_benefit_technical_support: "Slack을 통한 기술 지원",
  enterprise_plan_benefit_contain_pro_plan: "프로 플랜 혜택 모두 제공",
  enterprise_plan_benefit_tailored_training: "기업 맞춤형 교육 세션 제공",
  enterprise_plan_benefit_raw_data_and_analysis_consulting_line1: "Raw data 추출 및 데이터 분석",
  enterprise_plan_benefit_raw_data_and_analysis_consulting_line2: "컨설팅 제공",
  enterprise_plan_benefit_monitoring: "알람 및 모니터링 지원",
  enterprise_plan_benefit_SLA: "SLA 기반의 전담 지원",
  feature_flag_launch_event_title: "기능 플래그 출시 이벤트!",
  feature_flag_launch_event_desc: "이벤트 기간동안 플랜 상관없이 무제한 사용 가능! ({date}까지)",
  event_tooltip:
    "An event refers to a result of all actions triggered by users using the web/app service. It includes all user interactions (ex: button click, page view, purchase complete etc.) and user traffic distributions in A/B test or Feature flag.",
  collaborator_limit_free: "3 team member/workspace",
  collaborator_limit_pro: "Up to 10 team members/workspace",
  select_msg_free_plan: "스타트업 무료 플랜이 등록되었습니다.",
  select_msg_pro_plan: "프로 플랜이 등록되었습니다.",
  data_archiving_limit_free_plan: "Data stored for up to 2 months",
  data_archiving_limit_pro_plan: "Data stored for up to 6 months",
  email_support: "Email support in 1 business day",
  pro_plan_desc: "Unlimted number of events provided",
  payment_basic: "Base Fee",
  payment_event: "Per 1000 Events",
  enterprise_plan_benefit1: "Unlimited number of \nteam members",
  enterprise_plan_benefit2: "Data Export provided",
  enterprise_plan_benefit3: "SSO 및 인증 지원",
  enterprise_plan_benefit4: "Data stored for up to 12 months",
  enterprise_plan_benefit5: "SLA  based support",
  plan_overcharge_desc:
    "*Any additional usage amount that exceeds the Pro Plan limit will be billed in accordance to the charge prior to the promotion event. ",
  plan_tax_desc: "*VAT Excluded",
  free_charge: "Free-of-charge",
  funnel_promotion_1: "Unlimited use regardless of plan",
  funnel_promotion_2: "during the launch event period!",
  promotion_time_limit: "Launch Event! Until {date}",
  pro_plan_include_free_plan: "Everything in Free Startup Plan",
  plan_benefit_targeting: "User Targeting",
  enterprise_plan_include_pro_plan: "Everything in Pro Plan",
  btn_integration_guide: "Check out docs",
  sdk_integration: "SDK Integration",
  sdk_integration_title_line1: "Set up your app, web",
  sdk_integration_title_line2: "server in just 5 minutes",
  preview_video: "Watch demo",
  anomaly_detection: "Anomaly Detection",
  anomaly_detection_line1: "Check any issues real-time",
  anomaly_detection_line2: "via Monitoring Alarm",
  release_notifications: "Get release notifications",
  release_notifications_modal_title: "Get release notifications",
  request_release_notification_comment: "Please feel free to ask anything you'd like.",
  data_insight: "Data Insight",
  data_analytics: "Data Analytics",
  pro_plan_usage_limit: "*Once the number of events exceed 5,000,000 per month, $0.2 per 1000 events will be charged.",
  pro_plan_benefit_metric_type: "customizable metrics, etc. ",
  pro_plan_benefit_detail_line1: "(Audience Targeting, Monitoring Alarm,",
  pro_plan_benefit_detail_line2: "Segmentation, customizable metrics, etc.)",
  sign_in: "Sign In",
  cta_tour: "Explore Product",
  gnb_tour: "Explore Product",
  pricing_calculator_title: "Estimate the cost of your product!",
  pricing_calculator_business_type_commerce: "Commerce",
  pricing_calculator_business_type_social_media: "Social Media",
  pricing_calculator_business_type_education: "Education",
  pricing_calculator_business_type_others: "Others",
  pricing_calculator_category: "Category",
  pricing_calculator_mau: "Monthly Active Users",
  pricing_calculator_expected_usage: "Estimated Events Usage",
  pricing_calculator_recommended_plan: "Recommended",
  pricing_calculator_estimated_monthly_price: "Estimated Price{br}/ Month",
  pricing_calculator_notice:
    "* Estimated price is an example to help your understanding, actual price may differ according to event distribution in A/B test, feature flags, etc.",
  service_sdk_integration_title: "SDK integration",
  service_sdk_integration_title_2: "in just 5 minutes",
  service_sdk_integration_desc_1: "We provide both server and client-side SDK",
  service_sdk_integration_desc_1_2: "that can be used for both web and app platforms,",
  service_sdk_integration_desc_2: "allowing you to utilize Hackle's services",
  service_sdk_integration_desc_2_2: "on various environments.",
  DEVELOPERS_GUIDE: "Developer's Guide",
  GNB_GUIDES: "Guides",
  CTA_ANALYTICS: "Start Data Analytics",
  analytics_detail_page_data_insight_title: "Analyze user behaviors in just a few clicks!",
  analytics_detail_page_data_insight_desc_line1:
    "You can visualize and analyze a user's behavior data in a few clicks.",
  analytics_detail_page_data_insight_desc_line2:
    "Gain visibility into customer product usage, including user influx, conversion rate, and business KPI trends.",
  analytics_detail_page_summary_1: "Analyze inflow/visit, conversion rate, KPI, etc.",
  analytics_detail_page_summary_2: "Accurate results without data sampling",
  analytics_detail_page_summary_3: "Preview customized charts at a glance",
  event_management: "Event Management",
  event_management_real_time: "Real-time status and trend analysis",
  event_management_automatic: "Automatic event attribution collection",
  except_automatic_event: "Except automatic event collection",
  event_management_image: "Attach images to enhance event descriptions",
  analytics_summary_use_case_title: "Analyze inflow/visit, conversion rate, KPI, etc.",
  analytics_summary_without_sampling_title: "Accurate results without data sampling",
  analytics_summary_save_chart_title: "Preview customized charts at a glance",
  analytics_summary_use_case_desc: "Apply filters such as OS, route, and region to find out details of users.",
  analytics_summary_without_sampling_desc:
    "Data calculation is processed with real data, thus result is more reliable.",
  analytics_summary_save_chart_desc: "Check out automatically updated data chart on a single page",
  home_data_insight_description:
    "Gain visibility into customer product usage, including user influx, conversion rate, and business KPI trends.",
  home_retention_description_line1: "Retention is a product success indicator itself.",
  home_retention_description_line2: "Gain deep insights into user's stickiness under various conditions.",
}
